export function formatStringTimestamp(iso: string): { time: string; date: string } {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) {
    return { time: '', date: '' }
  }
  return {
    time: d.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    }),
    date: d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }),
  }
}

export function formatMemberSince(iso: string): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return ''
  return d.toLocaleDateString('en-US', { month: 'long', year: 'numeric' })
}
